import { StyleSheet,Dimensions} from 'react-native';
import { SIZES, PALETTE, MQ_TABLET} from '../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";
const WINDOW_WIDTH = Dimensions.get('window').width;
const WINDOW_HEIGHT = Dimensions.get('window').height;
 
export default MediaQueryStyleSheet.create({
  termsColor: {
    color: PALETTE.touchableOpacityEnable,
  },
  checkRead: {
    display: 'inline-Block',
    left: 20,
    width: screen.width * 0.5
  },
  errorColor: {
    color: PALETTE.errorColor,
  }
});